export default __webpack_public_path__ + "static/media/Sunderland2hrRapidResponseNursingTeam(R@H)GeneralGuidanceonRapidResponseNursingServices.4a49f09c.jpg";